var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.667 10a8.333 8.333 0 1 0 16.667 0 8.333 8.333 0 0 0-16.667 0Zm15 0a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0Zm-7.5-4.167a.833.833 0 1 1 1.667 0V10a.833.833 0 1 1-1.667 0V5.833ZM10 12.5a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Z"
  })));
};

export default SvgWarningCircle;